import React from 'react';
import { Grid, LinearProgress, Chip } from '@mui/material';
import Done from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import {translate} from "../../../translate/translate";
import {PoMonitoring, PoMonitoringStatus} from "../../../models/basic/po-monitoring";

const PoMonitoringStatusComponent = ({ obj }: { obj: PoMonitoring }) => {
    const renderLayout = () => {
        if (obj.status === PoMonitoringStatus.PENDING || obj.status === PoMonitoringStatus.ADDED) {
            return (
                <Grid
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        whiteSpace: 'nowrap',
                    }}
                >
                    <LinearProgress
                        variant="determinate"
                        color="secondary"
                        value={obj.completeness * 100}
                        style={{ width: '80%' }}
                    />
                    {obj.completeness * 100}%
                </Grid>
            );
        }

        const icon =
            obj.status === PoMonitoringStatus.COMPLETED ? (
                <Done style={{ fontSize: 'small' }} />
            ) : (
                < CloseIcon style={{ fontSize: 'small' }} />
            );

        const bgColor =
            obj.status === PoMonitoringStatus.COMPLETED ? 'secondary' : 'error';

        const label = (
            <Grid
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    whiteSpace: 'nowrap',
                    color: 'white',
                }}
            >
                {icon}
                {translate.t(PoMonitoringStatus[obj.status].toLowerCase())}
            </Grid>
        );

        return <Chip size="small" color={bgColor} label={label} />;
    };

    return <>{renderLayout()}</>;
};

export default PoMonitoringStatusComponent;
